import { render, staticRenderFns } from "./fileDownloadList.vue?vue&type=template&id=5fbb74cc&"
import script from "./fileDownloadList.vue?vue&type=script&lang=js&"
export * from "./fileDownloadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports